import React, { Component, createRef } from "react";
import "./pdv.css"; // Importa o CSS
import { apiUrl } from "../comp/ApiUrl";
import Cookies from "js-cookie";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from "@mui/material";

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { WithRouter } from "../comp/WithRouter";
import { toast } from "react-toastify";
// --- Configuração de Dados ---
const DORITOS_IMAGE_URL = "https://via.placeholder.com/150x200?text=Salgadinho+Doritos";

const calculateTotal = (items) => {
  return items.reduce((sum, item) => sum + item.total, 0);
};

// --- Componente de Classe ---
class PDV extends Component {
  // Buffer e Timer para Detecção do Scanner
  SCANNER_BUFFER = "";
  SCANNER_TIMER = null;

  constructor(props) {
    super(props);
    this.state = {
      barcodeInput: "",
      cartItems: [],
      store: [],
      fun: undefined,
      loading: false,
      openPaymentDialog: false,
      FinishPaymentDialog: false,
      FinishPaymentDialogStatus: 0,
      paymentType: null,
      valorPago: 0,
      search: false,
      activeStep: 0,
      termoBusca: '',
      produtos: [],
      isLoading: true,
      showLoader: false, // Alterado de loading para showLoader
      caixa: false
    };
    this.barcodeRef = createRef();

    // Bindings
    this.handleBarcodeSubmit = this.handleBarcodeSubmit.bind(this);
    this.renderItemList = this.renderItemList.bind(this);
    this.handleGlobalKeydown = this.handleGlobalKeydown.bind(this);
    this.processBarcode = this.processBarcode.bind(this);
    this.handlePaymentChoice = this.handlePaymentChoice.bind(this);
    this.finalizarVenda = this.finalizarVenda.bind(this);
    this.imprimirCupom80mm = this.imprimirCupom80mm.bind(this);
  }

  componentDidMount() {
    if (this.barcodeRef.current) {
      this.barcodeRef.current.focus();
    }


    fetch(`${apiUrl}/settings`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((data) => {
          this.setState({ store: data, caixa: data.caixa, isLoading: false });
        });
      }
    });




    document.addEventListener("keydown", this.handleGlobalKeydown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleGlobalKeydown);
    clearTimeout(this.SCANNER_TIMER);
  }

  componentDidUpdate(prevProps, prevState) {
    // Mantém o foco no input se o modal de pagamento não estiver aberto
    if (this.barcodeRef.current && !this.state.openPaymentDialog) {
      this.barcodeRef.current.focus();
    }
  }

  // --- Lógica de Detecção Automática do Scanner ---
  handleGlobalKeydown(e) {
    if (this.state.loading) return;

    const { cartItems, fun, openPaymentDialog, activeStep } = this.state;

    if (e.key === "End") {
      e.preventDefault();
      if (cartItems.length > 0) {
        this.setState({
          openPaymentDialog: true,
          activeStep: 0,
          paymentType: null,
          valorPago: 0,
        });
        return;
      }
    }

    if (openPaymentDialog && activeStep === 0) {
      if (e.key === "1") this.handlePaymentChoice("money");
      if (e.key === "2") this.handlePaymentChoice("qr");
      if (e.key === "3") this.handlePaymentChoice("credit_card");
      if (e.key === "4") this.handlePaymentChoice("debit_card");
      if (e.key === "5") this.handlePaymentChoice("voucher");
    }

    if (e.key === "Escape") {
      e.preventDefault();
      if (openPaymentDialog) {
        this.setState({ openPaymentDialog: false, activeStep: 0 });
        return;
      }

      if (fun !== undefined) {
        this.setState({
          fun: undefined,
          cartItems: cartItems.map((item, index) => ({
            ...item,
            selected: index === cartItems.length - 1,
          })),
        });
      }
      return;
    }





    if (e.key === "F5") {
      e.preventDefault();
      this.setState({ fun: "delete" });
      return;
    }






    if (e.key === "F4") {
      e.preventDefault();
      this.setState({ fun: "change" });
      return;
    }

    if (fun === "delete") {
      const currentIndex = cartItems.findIndex((item) => item.selected);
      let newIndex = currentIndex;

      switch (e.key) {
        case "ArrowUp":
          e.preventDefault();
          newIndex = Math.max(currentIndex - 1, 0);
          break;
        case "ArrowDown":
          e.preventDefault();
          newIndex = Math.min(currentIndex + 1, cartItems.length - 1);
          break;
        case "Delete":
          e.preventDefault();
          if (currentIndex !== -1) {
            const updatedItems = [...cartItems];
            updatedItems.splice(currentIndex, 1);
            const selectIndex = Math.min(currentIndex, updatedItems.length - 1);
            if (updatedItems[selectIndex]) updatedItems[selectIndex].selected = true;
            this.setState({ cartItems: updatedItems });
          }
          return;
        default:
          return;
      }

      const updatedItems = cartItems.map((item, index) => ({
        ...item,
        selected: index === newIndex,
      }));
      this.setState({ cartItems: updatedItems });
      return;
    }

    if (fun === "change") {
      const currentIndex = cartItems.findIndex((item) => item.selected);
      if (currentIndex === -1) return;
      let newIndex = currentIndex;
      switch (e.key) {
        case "ArrowUp":
          e.preventDefault();
          newIndex = Math.max(currentIndex - 1, 0);
          break;
        case "ArrowDown":
          e.preventDefault();
          newIndex = Math.min(currentIndex + 1, cartItems.length - 1);
          break;
        case "+":
        case "=":
          e.preventDefault();
          this.setState((prevState) => {
            const updated = [...prevState.cartItems];
            const item = updated[currentIndex];
            item.qtde += 1;
            item.total = item.qtde * item.valor;
            return { cartItems: updated };
          });
          return;
        case "-":
          e.preventDefault();
          this.setState((prevState) => {
            const updated = [...prevState.cartItems];
            const item = updated[currentIndex];
            if (item.qtde > 1) {
              item.qtde -= 1;
              item.total = item.qtde * item.valor;
            }
            return { cartItems: updated };
          });
          return;
        default:
          return;
      }

      const updatedItems = cartItems.map((item, index) => ({
        ...item,
        selected: index === newIndex,
      }));
      this.setState({ cartItems: updatedItems });
      return;
    }

    if (e.key === "Enter") {
      e.preventDefault();
      const code = this.SCANNER_BUFFER.trim();
      if (code) this.processBarcode(code);
      this.SCANNER_BUFFER = "";
      clearTimeout(this.SCANNER_TIMER);
      return;
    }

    if (e.key.length === 1 && /^[a-zA-Z0-9-]$/.test(e.key)) {
      this.SCANNER_BUFFER += e.key;
      clearTimeout(this.SCANNER_TIMER);
      this.SCANNER_TIMER = setTimeout(() => {
        this.SCANNER_BUFFER = "";
      }, 50);
    }
  }
  // Função auxiliar para formatar o número como moeda BRL (ex: 2.5 -> R$ 2,50)
  formatarMoedaBRL(valor) {
    if (!valor) return "R$ 0,00";
    // Converte para float caso venha como string
    const num = typeof valor === "number" ? valor : parseFloat(valor);
    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  // Função que limpa a formatação para salvar apenas o número no estado
  tratarMudancaValor(e) {
    let valorDigitado = e.target.value;

    // Remove tudo o que não for dígito numérico
    valorDigitado = valorDigitado.replace(/\D/g, "");

    // Se o usuário apagar tudo, define como 0
    if (!valorDigitado) {
      this.setState({ valorPago: 0 });
      return;
    }

    // Transforma os centavos de volta para float (ex: "250" vira 2.50)
    const valorFloat = parseFloat(valorDigitado) / 100;

    this.setState({ valorPago: valorFloat });
  }
  // --- Processamento do Código de Barras ---
  async processBarcode(code) {
    this.setState({ loading: true, barcodeInput: "" });
    try {
      const url = `${apiUrl}/buscar/produto/${code}`;
      const response = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ${response.status}: Produto não encontrado.`);
      }

      const productData = await response.json();
      const foundProduct = {
        produto_id: productData.id,
        cod: productData.ean,
        produto: productData.nome,
        imagem: productData.imagem,
        custo: productData.custo,
        valor: productData.preco,
        qtde: 1,
      };

      this.setState((prevState) => {
        let updatedItems;
        const existingItemIndex = prevState.cartItems.findIndex(
          (item) => item.cod === foundProduct.cod
        );

        if (existingItemIndex > -1) {
          updatedItems = prevState.cartItems.map((item, index) => {
            if (index === existingItemIndex) {
              const newQtde = item.qtde + 1;
              return { ...item, qtde: newQtde, total: newQtde * item.valor, selected: true };
            }
            return { ...item, selected: false };
          });
        } else {
          const newItem = {
            ...foundProduct,
            total: foundProduct.valor * foundProduct.qtde,
            selected: true,
          };
          updatedItems = [
            ...prevState.cartItems.map((item) => ({ ...item, selected: false })),
            newItem,
          ];
        }
        return { cartItems: updatedItems, loading: false };
      });
    } catch (error) {
      alert(`Erro na busca: ${error.message}`);
      this.setState({ loading: false });
    }
  }

  handleBarcodeSubmit(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const code = this.state.barcodeInput.trim();
      if (code) this.processBarcode(code);
    }
  }

  handlePaymentChoice(type) {
    this.setState({
      paymentType: type,
      activeStep: 1,
    });
  }


  printPixQrCode(base64Image) {
    // Cria uma nova janela/aba para a impressão
    const printWindow = window.open('', '_blank', 'width=400,height=500');

    // Formata o HTML especificamente para papel de 80mm
    printWindow.document.write(`
  <html>
    <head>
      <title>Imprimir PIX</title>
      <style>
        @page {
          size: 80mm auto;
          margin: 0;
        }
        body {
          font-family: Arial, sans-serif;
          width: 72mm; /* Margem de segurança para impressora de 80mm */
          margin: 0 auto;
          text-align: center;
          padding: 10px 0;
        }
        .text {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        img {
          /* Define um tamanho fixo ideal para o QR Code no papel de 80mm */
          width: 45mm; 
          height: 45mm;
          display: block;
          margin: 0 auto;
        }
      </style>
    </head>
    <body>
      <div class="text">PAGAMENTO PIX</div>
      <!-- Removemos espaços extras e garantimos a tag limpa -->
      <img src="data:image/png;base64,${base64Image}" id="qrCode" />
      
      <script>
        // Garante que a imagem está totalmente carregada na nova janela antes de imprimir
        window.onload = function() {
          setTimeout(function() {
            window.print();
            window.close();
          }, 250); // Um pequeno delay ajuda o motor de renderização da impressora
        };
      </script>
    </body>
  </html>
`);

    printWindow.document.close();
    printWindow.focus();
  }



  // --- Função de Impressão Térmica (80mm) ---
  imprimirCupom80mm(itensVendidos, totalGeral, formaPagamento, valorPago, troco, store) {
    const dataHora = new Date().toLocaleString("pt-BR");

    // Define a largura máxima de caracteres para impressoras de 80mm
    const LARGURA_MAX = 48;

    // Função para remover acentos e caracteres especiais de forma global
    const limparTexto = (texto) => {
      if (!texto) return "";
      return String(texto)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Remove acentos
        .replace(/[^\x20-\x7E]/g, ""); // Garante apenas caracteres ASCII imprimíveis
    };

    // Função auxiliar para alinhar textos nas extremidades (Esquerda e Direita)
    const alinharLinha = (esquerda, direita) => {
      const esqLimpo = limparTexto(esquerda);
      const dirLimpo = limparTexto(direita);
      const espacosNecessarios = LARGURA_MAX - esqLimpo.length - dirLimpo.length;
      return esqLimpo + " ".repeat(Math.max(0, espacosNecessarios)) + dirLimpo + "\n";
    };

    // Função auxiliar para centralizar texto de forma segura
    const centralizar = (texto) => {
      const textoLimpo = limparTexto(texto).substring(0, LARGURA_MAX); // Corta se for maior que a bobina
      const espacos = Math.max(0, Math.floor((LARGURA_MAX - textoLimpo.length) / 2));
      return " ".repeat(espacos) + textoLimpo + "\n";
    };

    let textoCupom = "";

    // ================= CABEÇALHO DA LOJA =================
    textoCupom += "================================================\n";
    textoCupom += centralizar(store.nome);
    if (store.cnpj) textoCupom += centralizar(`CNPJ: ${store.cnpj}`);

    if (store.address) {
      const enderecoCompleto = `${store.address.rua || ''}, ${store.address.numero || ''} - ${store.address.cidade || ''}`;
      // Se o endereço for muito longo, quebra em duas linhas no cupom de forma inteligente
      if (enderecoCompleto.length > LARGURA_MAX) {
        textoCupom += centralizar(enderecoCompleto.substring(0, LARGURA_MAX));
        textoCupom += centralizar(enderecoCompleto.substring(LARGURA_MAX, LARGURA_MAX * 2));
      } else {
        textoCupom += centralizar(enderecoCompleto);
      }
    }

    if (store.telefone) textoCupom += centralizar(`Telefone: ${store.telefone}`);
    textoCupom += "================================================\n";
    textoCupom += centralizar("CUPOM NAO FISCAL");
    textoCupom += "================================================\n";

    textoCupom += `Data/Hora: ${dataHora}\n`;
    textoCupom += "------------------------------------------------\n";
    textoCupom += "COD   PRODUTO             QTD    VL.UNT     TOTAL\n";
    textoCupom += "------------------------------------------------\n";

    // ================= ITENS DA VENDA =================
    itensVendidos.forEach((item) => {
      const produtoSemAcento = limparTexto(item.produto);

      // Formatação estrita por tamanho de colunas para somar exatamente 48 caracteres
      const codFormatado = String(item.cod).substring(0, 5).padEnd(5, " ");          // 5 caracteres
      const nomeCortado = produtoSemAcento.substring(0, 17).padEnd(17, " ");       // 17 caracteres
      const qtdFormatada = String(item.qtde).substring(0, 4).padStart(4, " ");       // 4 caracteres
      const valUnit = item.valor.toFixed(2).replace(".", ",").substring(0, 10).padStart(10, " "); // 10 caracteres
      const valTotal = item.total.toFixed(2).replace(".", ",").substring(0, 10).padStart(10, " "); // 10 caracteres

      // Montagem da linha (5 + 1 + 17 + 1 + 4 + 1 + 10 + 9(paddings restantes)) = 48
      // Para garantir o alinhamento perfeito baseando-se nos tamanhos definidos:
      textoCupom += `${codFormatado} ${nomeCortado} ${qtdFormatada} ${valUnit}${valTotal}\n`;
    });

    textoCupom += "------------------------------------------------\n";

    // ================= FECHAMENTO =================
    const totalStr = `R$ ${totalGeral.toFixed(2).replace(".", ",")}`;
    textoCupom += alinharLinha("TOTAL:", totalStr);

    textoCupom += alinharLinha("Forma de Pagto:", formaPagamento.toUpperCase());

    // Verificação robusta da forma de pagamento
    const formaPagtoNorm = limparTexto(formaPagamento).toLowerCase();
    if (formaPagtoNorm === "money" || formaPagtoNorm.includes("money")) {
      const pagoStr = `R$ ${parseFloat(valorPago || 0).toFixed(2).replace(".", ",")}`;
      const trocoStr = `R$ ${troco.toFixed(2).replace(".", ",")}`;
      textoCupom += alinharLinha("Valor Pago:", pagoStr);
      textoCupom += alinharLinha("Troco:", trocoStr);
    }

    textoCupom += "================================================\n";
    textoCupom += centralizar("Obrigado pela preferencia!");
    textoCupom += "================================================\n";
    textoCupom += "\n\n\n\n\n"; // Espaço físico para guilhotina/corte manual

    // Abre a janela para impressão
    const janelaImpressao = window.open("", "_blank", "width=400,height=600");

    janelaImpressao.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Imprimir Cupom</title>
          <style>
            /* Remove margens de impressão do navegador (Headers/Footers com URL) */
            @page { 
              margin: 0; 
            }
            html, body {
              margin: 0;
              padding: 0;
              background-color: #ffffff;
            }
            body { 
              font-family: 'Courier New', Courier, monospace; 
              font-size: 12px; 
              font-weight: bold;
              color: #000000;
              width: 72mm; /* Largura ideal de impressão util para bobinas de 80mm */
              padding: 4mm;
              white-space: pre;
              box-sizing: border-box;
            }
            /* Força renderização preta e branca limpa */
            @media print {
              body {
                width: 72mm;
              }
            }
          </style>
        </head>
        <body>${textoCupom}</body>
      </html>
    `);

    janelaImpressao.document.close();
    janelaImpressao.focus();

    // O tempo de 500ms é excelente para o DOM renderizar o CSS antes do diálogo de impressão aparecer
    setTimeout(() => {
      janelaImpressao.print();
      janelaImpressao.close();
    }, 500);
  }

  // --- Finalizar a Venda no Backend ---

  async finalizarVenda() {
    const { cartItems, paymentType, valorPago } = this.state;
    const mp = this.state.store.payments.mp;
    const totalGeral = calculateTotal(cartItems);
    const troco = parseFloat(valorPago || 0) - totalGeral;

    this.setState({ loading: true });

    // 1. Cenário: Pagamento em Dinheiro ou Sem Mercado Pago configurado
    if (mp == false || paymentType === "money") {
      try {
        const response = await fetch(`${apiUrl}/realizar/venda`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("auth_token"),
          },
          body: JSON.stringify({
            itens: cartItems,
            formaPagamento: paymentType,
            valorPago: parseFloat(valorPago || 0)
          }),
        });

        if (!response.ok) {
          throw new Error("Falha ao registrar venda no servidor.");
        }

        this.imprimirCupom80mm(cartItems, totalGeral, paymentType, valorPago, troco, this.state.store);

        // Reseta o PDV para a próxima venda
        this.setState({
          cartItems: [],
          openPaymentDialog: false,
          activeStep: 0,
          paymentType: null,
          valorPago: "",
          fun: undefined,
          loading: false
        });

      } catch (error) {
        console.error(error);
        toast.error(error.message || 'Erro ao registrar venda no servidor.');
        this.setState({ loading: false });
      }

      // 2. Cenário: Integração com Mercado Pago (Via Server-Sent Events / Stream)
    } else {
      try {
        // Cria a intenção de venda no backend
        const responseVenda = await fetch(`${apiUrl}/realizar/venda/mp`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("auth_token"),
          },
          body: JSON.stringify({
            itens: cartItems,
            formaPagamento: paymentType,
            valorPago: parseFloat(valorPago || 0)
          }),
        });

        if (!responseVenda.ok) {
          throw new Error("Falha ao iniciar a venda com Mercado Pago.");
        }

        const data = await responseVenda.json();




        // Abre o modal de aguardando pagamento
        this.setState({
          openPaymentDialog: false,
          FinishPaymentDialog: true,
          FinishPaymentDialogStatus: 1
        });

        // Inicializa o canal SSE para escutar o status do pagamento
        const eventSource = new EventSource(`${apiUrl}/vendas/stream/${data.vendaId}`);

        eventSource.onmessage = (event) => {
          try {
            const dadosStream = JSON.parse(event.data);
            console.log(dadosStream);





            if (dadosStream.status === "processed" || dadosStream.status === "approved") {
              eventSource.close();
              toast.success('Venda finalizada com sucesso!');
              this.setState({
                cartItems: [],
                openPaymentDialog: false,
                FinishPaymentDialog: false,
                activeStep: 0,
                paymentType: null,
                valorPago: "",
                fun: undefined,
                loading: false
              }, () => {
                setTimeout(() => {
                  this.imprimirCupom80mm(cartItems, totalGeral, paymentType, valorPago, troco, this.state.store);

                }, 300)
              });



            }

            if (dadosStream.status === "canceled") {
              eventSource.close();
              toast.error('Venda cancelada no Mercado Pago.');
              this.setState({
                FinishPaymentDialogStatus: -1,
                loading: false
              });
            }



            if (dadosStream.status === "failed") {
              eventSource.close();
              toast.error('O Pagamento falhou!');
              this.setState({
                FinishPaymentDialogStatus: -2,
                loading: false
              });
            }



          } catch (err) {
            console.error("Erro ao processar dados do stream:", err);
          }
        };

        eventSource.onerror = (error) => {
          console.error("Erro na comunicação em tempo real (SSE):", error);
          // Não fechamos o eventSource aqui porque o navegador tenta reconectar automaticamente
        };

        this.eventSourceAtual = eventSource;

        // Envia a ordem para a maquininha/Dispositivo do Mercado Pago
        const responseMp = await fetch(`${apiUrl}/mercadopago/venda`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: data.vendaId })
        });

        if (!responseMp.ok) {
          throw new Error("Falha ao enviar a venda para o Mercado Pago.");
        }


        if (paymentType == "qr") {
          var process_qr = await responseMp.json();

          this.printPixQrCode(process_qr.qr);
          this.setState({ FinishPaymentDialogStatus: 'qr' });
        } else {
          this.setState({ FinishPaymentDialogStatus: 2 });
        }






      } catch (error) {
        console.error(error);
        toast.error(error.message || 'Erro ao processar pagamento via Mercado Pago.');

        // Fecha o modal de pagamento caso tenha aberto e desativa o loading
        this.setState({
          loading: false,
          FinishPaymentDialog: false
        });

        if (this.eventSourceAtual) {
          this.eventSourceAtual.close();
        }
      }
    }
  }



  renderItemList() {
    return (
      <table className="pdv-item-list">
        <thead className="pdv-item-header">
          <tr>
            <th className="item-cell">CÓDIGO</th>
            <th className="item-cell">PRODUTO</th>
            <th className="item-cell">VALOR</th>
            <th className="item-cell">QTD.</th>
            <th className="item-cell" style={{ textAlign: "right" }}>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {this.state.cartItems.map((item, index) => (
            <tr
              key={item.cod + "-" + index}
              className={`pdv-item-row ${item.selected ? "pdv-selected-item-row" : ""}`}
            >
              <td className="item-cell">{item.cod}</td>
              <td className="item-cell">{item.produto}</td>
              <td className="item-cell">R$ {item.valor.toFixed(2).replace(".", ",")}</td>
              <td className="item-cell">{item.qtde}</td>
              <td className="item-cell" style={{ textAlign: "right" }}>
                R$ {item.total.toFixed(2).replace(".", ",")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
  handleSearchChange = (e) => {
    const valor = e.target.value;
    this.setState({ termoBusca: valor });

    if (this.timeout) clearTimeout(this.timeout);

    if (valor.trim() === '') {
      this.setState({ produtos: [] });
      return;
    }

    this.timeout = setTimeout(() => {
      this.buscarProdutos(valor);
    }, 500);
  };

  buscarProdutos = (busca) => {
    this.setState({ showLoader: true }); // Ativa o loader antes do fetch

    fetch(`${apiUrl}/search/products?search=${encodeURIComponent(busca)}`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({ produtos: data, showLoader: false }); // Desativa o loader
      })
      .catch((err) => {
        console.error('Erro ao buscar produtos:', err);
        this.setState({ showLoader: false, produtos: [] });
      });
  };

  handleSelectProduto = (produto) => {
    if (this.props.onSelectProduto) {
      this.props.onSelectProduto(produto);
    }
    this.fecharDialog();
  };

  fecharDialog = () => {
    this.setState({ termoBusca: '', produtos: [], showLoader: false });
    this.setState({ search: false });
  };
  render() {
    const { cartItems, barcodeInput, loading, openPaymentDialog, activeStep, paymentType, valorPago, fun, FinishPaymentDialog } = this.state;
    const { termoBusca, produtos, showLoader } = this.state;
    const totalGeral = calculateTotal(cartItems);
    const selectedItem = cartItems.find((item) => item.selected) || {
      cod: "N/A",
      produto: "Nenhum item selecionado",
      valor: 0.0,
      qtde: 0,
      total: 0.0,
      imagem: null,
    };

    const imageUrl = selectedItem.imagem ? `${apiUrl}/static/${selectedItem.imagem}` : DORITOS_IMAGE_URL;
    const imageBackgroundColor = selectedItem.imagem ? "white" : "black";
    const trocoCalculado = parseFloat(valorPago || 0) - totalGeral;


    if (this.state.isLoading == true) {
      return (
        <div className="pdv-container">
          <div className="pdv-header">
            <div>Carregando...</div>
          </div>
        </div>
      );
    }

    if (this.state.caixa == false) {
      return (
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '80vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2
          }}
        >
          <Container maxWidth="sm">
            <Card
              elevation={3}
              sx={{
                textAlign: 'center',
                p: 4,
                borderRadius: 3
              }}
            >
              <CardContent>
                {/* Ícone de Alerta/Bloqueio */}
                <Box
                  sx={{
                    backgroundColor: 'error.light',
                    color: 'error.main',
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px'
                  }}
                >
                  <LockOutlinedIcon sx={{ fontSize: 40 }} />
                </Box>

                {/* Título */}
                <Typography variant="h5" component="h1" gutterBottom fontWeight="bold">
                  Caixa Fechado
                </Typography>

                {/* Mensagem Explicativa */}
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                  Para acessar as funções do PDV e realizar vendas, é necessário efetuar a abertura do caixa primeiro.
                </Typography>

                {/* Botão de Ação */}
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  onClick={() => {
                    this.props.navigate('/box');
                  }}
                  sx={{
                    py: 1.5,
                    fontWeight: 'bold',
                    textTransform: 'none',
                    borderRadius: 2
                  }}
                >
                  Abrir Caixa Agora
                </Button>
              </CardContent>
            </Card>
          </Container>
        </Box>
      );
    }



    return (
      <div className="pdv-container">
        {/* Top Header */}
        <div className="pdv-header">
          <div>{fun || "---"}</div>
          <div>Obrigado pela preferência, volte sempre!</div>
          <div>---</div>
          <div>---</div>
        </div>

        {/* Title Bar */}
        <div className="pdv-title-bar">
          {loading ? "BUSCANDO PRODUTO..." : openPaymentDialog ? "FINALIZANDO..." : selectedItem.produto.toUpperCase()}
          <span style={{ fontSize: "24px" }}>🔍</span>
        </div>

        {/* Main Content Area */}
        <div className="pdv-main-content">
          <div className="pdv-left-panel">
            <div className="code-section">
              <div className="code-label">CÓDIGO (Leia ou Digite)</div>
              <input
                ref={this.barcodeRef}
                type="text"
                value={barcodeInput}
                onChange={(e) => this.setState({ barcodeInput: e.target.value })}
                onKeyDown={this.handleBarcodeSubmit}
                disabled={loading || openPaymentDialog}
                className="code-input"
                placeholder={loading ? "AGUARDE..." : openPaymentDialog ? "RESTA" : "Aguardando Leitura..."}
              />
            </div>
            <div className="pdv-product-detail">
              <div className="pdv-product-image" style={{ backgroundColor: imageBackgroundColor }}>
                {loading ? (
                  <span style={{ color: "white", fontSize: "14px" }}>Carregando...</span>
                ) : selectedItem.cod !== "N/A" && selectedItem.imagem ? (
                  <img src={imageUrl} alt={selectedItem.produto} style={{ maxWidth: "100%", maxHeight: "100%" }} />
                ) : (
                  <span style={{ color: selectedItem.cod !== "N/A" ? "white" : "#999", fontSize: "10px" }}>
                    Sem Imagem
                  </span>
                )}
              </div>
              <div className="pdv-product-info">
                <div className="info-box info-box-blue">
                  <div className="info-label">VALOR UNIT.</div>
                  <div className="info-value">R$ {selectedItem.valor.toFixed(2).replace(".", ",")}</div>
                </div>
                <div className="info-box info-box-medium">
                  <div className="info-label">QUANTIDADE</div>
                  <div className="info-value">{selectedItem.qtde}</div>
                </div>
                <div className="info-box info-box-purple">
                  <div className="info-label">TOTAL PARCIAL</div>
                  <div className="info-value">R$ {selectedItem.total.toFixed(2).replace(".", ",")}</div>
                </div>
              </div>
            </div>

            <div className="pdv-shortcuts">
              <div className="shortcut-item">F4 - Quantidade</div>
              <div className="shortcut-item">F5 - Excluir</div>
              <div className="shortcut-item">END - Finalizar</div>
              <div className="shortcut-item">ESC - Sair</div>
            </div>
          </div>

          <div className="pdv-right-panel">
            <div className="pdv-center-panel">{this.renderItemList()}</div>
            <div className="pdv-screen"></div>
          </div>
        </div>

        {/* Footer */}
        <div className="pdv-footer">
          <div className="pdv-toggle-group"></div>
          <div className="pdv-logo-and-total">
            <div className="pdv-item-count">
              <span>{cartItems.length}</span>
              <span style={{ fontSize: "12px", fontWeight: "normal", color: "#555" }}>ITENS</span>
            </div>
            <div className="pdv-total-box" onClick={() => cartItems.length > 0 && this.setState({ openPaymentDialog: true })}>
              <div className="pdv-total-label">TOTAL</div>
              <div className="pdv-total-value">R$ {totalGeral.toFixed(2).replace(".", ",")}</div>
            </div>
          </div>
        </div>


        <Dialog
          open={this.state.search}
          onClose={() => {
            this.setState({ search: false });
            this.setState({ termoBusca: "" });
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Buscar Produto</DialogTitle>

          <DialogContent dividers>
            <TextField
              label="Digite o nome do produto"
              autoFocus
              fullWidth
              value={termoBusca}
              onChange={(event) => {
                this.setState({ termoBusca: event.target.value });

              }}
              sx={{ mb: 2, mt: 1 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: showLoader && (
                  <InputAdornment position="end">
                    <CircularProgress size={20} /> {/* O componente loader do MUI */}
                  </InputAdornment>
                )
              }}
            />

            {/* Lista de Resultados */}
            <List sx={{ maxHeight: 300, overflow: 'auto' }}>
              {produtos.map((produto) => (
                <ListItem key={produto.id} disablePadding>
                  <ListItemButton onClick={() => this.handleSelectProduto(produto)}>
                    <ListItemText
                      primary={produto.nome}
                      secondary={produto.preco ? `R$ ${produto.preco}` : null}
                    />
                  </ListItemButton>
                </ListItem>
              ))}

              {produtos.length === 0 && termoBusca.trim() !== '' && !showLoader && (
                <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 2 }}>
                  Nenhum produto encontrado.
                </Typography>
              )}
            </List>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.fecharDialog} color="inherit">
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>




        {/* MATERIAL UI DIALOG - FINALIZAR VENDA */}
        <Dialog
          open={openPaymentDialog}
          onClose={() => this.setState({ openPaymentDialog: false, activeStep: 0 })}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Finalizar Venda</DialogTitle>

          <DialogContent>
            <Stepper activeStep={activeStep} sx={{ mb: 3, mt: 2 }}>
              <Step>
                <StepLabel>Pagamento</StepLabel>
              </Step>
              <Step>
                <StepLabel>Detalhes</StepLabel>
              </Step>
            </Stepper>

            {/* PASSO 0: Seleção de Forma de Pagamento */}
            {activeStep === 0 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography variant="subtitle1">
                  Selecione a forma de pagamento
                </Typography>
                <Button variant="contained" color="primary" onClick={() => this.handlePaymentChoice("money")}>
                  1 - Dinheiro
                </Button>
                <Button variant="contained" color="primary" onClick={() => this.handlePaymentChoice("qr")}>
                  2 - PIX
                </Button>
                <Button variant="contained" color="primary" onClick={() => this.handlePaymentChoice("credit_card")}>
                  3 - Crédito
                </Button>
                <Button variant="contained" color="primary" onClick={() => this.handlePaymentChoice("debit_card")}>
                  4 - Debito
                </Button>
                <Button variant="contained" color="primary" onClick={() => this.handlePaymentChoice("voucher")}>
                  5 - Voucher
                </Button>
              </Box>
            )}

            {/* PASSO 1: Detalhes Dinâmicos */}
            {activeStep === 1 && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Total a Pagar: R$ {totalGeral.toFixed(2).replace(".", ",")}
                </Typography>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Metodo de Pagamento: {paymentType}
                </Typography>

                {paymentType === "money" && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <TextField
                      label="Valor Recebido"
                      autoFocus
                      type="text" // Mudado para text para aceitar a formatação visual
                      value={this.formatarMoedaBRL(this.state.valorPago)}
                      onChange={(e) => this.tratarMudancaValor(e)}
                      fullWidth
                    />
                    <Typography variant="h5" color={trocoCalculado >= 0 ? "success.main" : "error.main"}>
                      Troco: R$ {trocoCalculado >= 0 ? trocoCalculado.toFixed(2).replace(".", ",") : "0,00"}
                    </Typography>
                  </Box>
                )}

                {paymentType === "pixo" && (
                  <Box sx={{ textAlign: "center", py: 2 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>Aguardando pagamento via QR Code...</Typography>

                  </Box>
                )}

                {paymentType === "cartaoo" && (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>Iniciando comunicação com a maquininha...</Typography>
                  </Box>
                )}
              </Box>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={() => this.setState({ openPaymentDialog: false, activeStep: 0 })} color="inherit">
              Cancelar
            </Button>
            {activeStep === 1 && (
              <Button
                variant="contained"
                color="success"
                onClick={this.finalizarVenda}
                disabled={loading || (paymentType === "dinheiro" && parseFloat(valorPago || 0) < totalGeral)}
              >
                {loading ? "Processando..." : this.state.store.payments.mp == true ? 'Pagamento' : 'Finalizar Venda'}
              </Button>
            )}
          </DialogActions>
        </Dialog>



        <Dialog
          open={FinishPaymentDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Pagamento</DialogTitle>


          <DialogContent>


            {this.state.FinishPaymentDialogStatus == -1 && (
              <Box sx={{ textAlign: "center", py: 4 }}>

                <Typography sx={{ mt: 2 }}>Pagamento Cancelado!</Typography>
              </Box>
            )}


            {this.state.FinishPaymentDialogStatus == -2 && (
              <Box sx={{ textAlign: "center", py: 4 }}>

                <Typography sx={{ mt: 2 }}>Pagamento Falhou!</Typography>
              </Box>
            )}



            {this.state.FinishPaymentDialogStatus == 1 && (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>Iniciando Comunicação com a maquininha...</Typography>
              </Box>
            )}


            {this.state.FinishPaymentDialogStatus == 'qr' && (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>Aguardando Pagamento PIX...</Typography>
              </Box>
            )}




            {this.state.FinishPaymentDialogStatus == 2 && (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>Aguardando pagamento na Maquininha...</Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="error">
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>



      </div>
    );
  }
}

export default WithRouter(PDV);